export const discount_type = function () {
    return [{label: '满减券', value: 1},
        {label: '通用券', value: 2},
        {label: '折扣券', value: 3},
        {label: '新人券', value: 4},
        {label: '老客户', value: 5},
        {label: '大客户券', value: 6}]
};
export const getBasePrice=function (detail){
    if (detail.discount_usage.price.value){
        return `满${detail.discount_usage.price.value}元可用`;
    }
    return  '无门槛优惠券';
}
export const formatPrice=function (detail) {
    let price = detail.discount_usage.type;
    if (price.condition === 2) {
        //折扣券
        let discount=Math.floor((1-parseFloat(price.value))*100);
        return  discount;
    } else {
        return price.value;
    }
}
